import { createSlice } from '@reduxjs/toolkit';

// Инициализируем loged и user из localStorage, если пользователь уже залогинен
const storedLoged = typeof window !== 'undefined' ? window.localStorage.getItem('uloged') : false;
const storedUser = typeof window !== 'undefined' ? window.localStorage.getItem('user') : null;

const initialState = {

	valuta: [],
	navbases:null,
	tags:[],
	brands:null,
	minprc:0,
	dprt:[],
	kurs:[],
	manufactura: null,
	topnav: null,
	loged: storedLoged && storedLoged !== 'false' ? true : false,
	user: storedUser ? JSON.parse(storedUser).fio : null,
	meta:{ttl:'', dsc:'', kwrd:''},
	setup:{
			// Empty string for relative paths (avoids Mixed Content errors with HTTPS)
			domen: '',
			// Base path from environment variable
			folder: import.meta.env.VITE_BASE_PATH || '',
			imgdomen:'/pics',
			api: "/api/",
		    lang: 'ru',
		    base:1,
		    bases:1,
		smode:true,
		    navid: []
	}
};

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
		LOAD_NAV_IDS:(state, action) => {
			state.setup = {...state.setup, navid:action.payload} 
		},

		LOAD_MANUFACTUR:(state, action) => {
				state.manufactura = action.payload.manufactura, 
				state.valuta = action.payload.valuta
		},

		SET_META:(state, action) => {
			state.meta = action.payload
		},

		SET_LOGED:(state, action) => {
			state.loged = action.payload
		},
		SET_UNAME:(state, action) => {
			state.user = action.payload
		},

		SET_NAVBASES:(state, action) => {
			state.navbases = action.payload 
		},

		SET_MIN_PRC:(state, action) => {
			state.minprc = action.payload 
		},

		SET_BRANDS:(state, action) => {
			state.brands = action.payload 
		},

		SET_TAGS:(state, action) => {
			state.tags = action.payload 
		},

		SET_KURS:(state, action) => {
			state.kurs = action.payload 
		},

		SET_TOPNAV:(state, action) => {
			state.topnav = action.payload 
		},

		SET_LANG:(state, action) => {
			state.setup = {...state.setup, lang:action.payload}
		},		

		SMODE:(state, action) => {
			state.setup = {...state.setup, smode:action.payload}
		}
	}
})

export const { 
	LOAD_NAV_IDS,
	LOAD_MANUFACTUR,
	SET_NAVBASES,
	SET_BRANDS,
	SET_KURS,
	SET_TAGS,
	SMODE,
	SET_META,
	SET_TOPNAV,
	SET_LANG,
	SET_UNAME,
	SET_LOGED,
	SET_MIN_PRC
} = siteSlice.actions

export default siteSlice.reducer